<template>
  <div class="fancy-feature-twentySeven lg-container pt-100 pt-20 md-mt-60 md-mb-20" id="feature">
    <div class="container">
      <div class="title-style-twelve text-center mb-70 md-mb-20">
        <div class="row">
          <div class="col-xl-10 col-lg-11 m-auto">
            <h2>
              <span> Your Robotics Journey Starts Here
                <img src="../../assets/images/shape/line-shape-13.svg" alt="" /></span>
            </h2>
            <p class="mt-40 md-mt-30">Along with our products, there are free tutorials on how to make robots</p>
            <p class="">
              Our learners follow a clear, practical path: </p>
          </div>
        </div>
      </div>

      <div class="row box">

        <div v-for="item in featureData" :key="item.id" class="col-lg-4 col-sm-6 " data-aos="fade-up"
          :data-aos-delay="item.delay">
          <div class="block-style-twentySeven">

            <h4 class="font-gordita">{{ item.title }}</h4>
            <p>{{ item.subtitle }}</p>
          </div>
          <!-- /.block-style-twentySeven -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FancyFeatureTwo",
  data() {
    return {
      featureData: [
        {
          id: 1,

          title: "Skill Assessment ",
          subtitle: "Start with a quick test to find your level. ",
        },
        {
          id: 2,

          title: "Project Selection ",
          subtitle: "Choose robotics projects tailored to your skills.",
          delay: "100",
        },
        {
          id: 3,

          title: "Micro-Lessons + AI Tutor",
          subtitle: "Learn through micro-lessons and an AI tutor.",

          delay: "200",
        },
        {
          id: 4,

          title: "Cloud Simulation",
          subtitle: "Test and debug your code in real-time.",

          delay: "200",
        },
        {
          id: 5,

          title: "Program Robots from Anywhere",
          subtitle: "Deploy code to real robots using CloudBox.",

          delay: "200",
        },
        {
          id: 6,
          title: "Build Your Portfolio ",
          subtitle: "Graduate with completed projects you can showcase.",

          delay: "200",
        },

      ],
    };
  },
};
</script>
